import PropTypes from 'prop-types';
import CssClassMixin from '../../mixins/css_class_mixin.jsx';
import InputComponentMixin from '../../mixins/input/input_component_mixin.jsx';

var createClass = require('create-react-class');

window.InputText = createClass({
  mixins: [CssClassMixin, InputComponentMixin],
  propTypes: {
    type: PropTypes.string
  },

  getDefaultProps: function() {
    return {
      type: 'text',
      themeClassKey: 'input.text'
    };
  },

  render: function() {
    return (
      <input {...this.props}
        value={this.state.value}
        placeholder={this.getPlaceholder()}
        className={this.inputClassName()}
        onChange={this._handleChange}
        onFocus={this._handleFocus}
        ref="input"
      />
    );
  }
});
